import React from "react";

import { PrismicColor } from "utils";

import {
  Column,
  Columns,
  Heading,
  Inline,
  Link,
  Text,
  VStack,
  Wrapper,
} from "components";

function ReportItem({ title, link }) {
  if (title && link && link.url)
    return (
      <VStack space="layout.1">
        <Text children={title} size={700} />
        <Link href={link.url}>
          <Text children="PDF" size={500} color="brand.secondary" />
        </Link>
      </VStack>
    );
  else return null;
}

export function FinancialReports({ title, items, background }) {
  if (items && items[0] && items[0].year)
    return (
      <Wrapper
        id={title && title.text}
        py={{ _: "layout.5", md: "layout.6" }}
        bg={PrismicColor(background)}
      >
        <Columns spaceX="layout.5" spaceY="layout.4">
          {/* Title */}
          <Column width={{ _: 1 / 1, lg: 4 / 12 }}>
            {title && title.text && (
              <Heading children={title.text} as="h2" size={700} />
            )}
          </Column>

          {/* Reports */}
          <Column width={{ _: 1 / 1, lg: 8 / 12 }}>
            <VStack as="ol" space={{ _: "layout.4", md: "layout.5" }}>
              {items.map((item, i) => {
                if (item && item.year)
                  return (
                    <Columns
                      spaceX="layout.5"
                      spaceY="layout.2"
                      key={`year-${i}`}
                    >
                      {/* Year */}
                      <Column width={{ _: 1 / 1, md: 4 / 12, lg: 2 / 8 }}>
                        <Heading children={item.year} size={700} />
                      </Column>
                      {/* Documents */}
                      <Column width={{ _: 1 / 1, md: 8 / 12, lg: 6 / 8 }}>
                        <Inline as="ol" space="layout.3">
                          <ReportItem title="Q1" link={item.q1_report} />
                          <ReportItem title="Q2" link={item.q2_report} />
                          <ReportItem title="Q3" link={item.q3_report} />
                          <ReportItem title="Q4" link={item.q4_report} />
                          <ReportItem title="AIF" link={item.aif} />
                        </Inline>
                      </Column>
                    </Columns>
                  );
                else return null;
              })}
            </VStack>
          </Column>
        </Columns>
      </Wrapper>
    );
  else return null;
}
